export const formatBoolean = (value, options = {}) => {
  const labels = options.labels || { "true": "ja", "false": "nein", "undefined": "" };
  if (typeof value === "boolean" || typeof value === "undefined") return labels[String(value)];
  if (typeof value === "number" || !isNaN(value)) {
    if (Number(value) === 0) return labels["false"];
    if (Number(value) === 1) return labels["true"];
  }
  if (typeof value === "string") {
    if (value.match(/^(n|no|nein|false)$/i)) return labels["false"];
    if (value.match(/^(j|ja|yes|true)$/i)) return labels["true"];
  }
  return labels["undefined"];
};

export const toBooleanJN = (value) => {
  if (String(value).match(/^(J|Y|ja|1|true)$/i)) return "J";
  if (String(value).match(/^(N|nein|no|0|false)$/i)) return "N";
};
